import { Abstract } from './abstract';
import { Order } from './order';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';
import { PreJaabstracts } from 'app/civil/civil-case-sections/pre-jaabstracts';

export class Pleading {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
     }

    getPleadingKey(): string {
        return this.key;
    }
    getResponseList(pleading: any): any[] {
        const present = SafeJSON.get('responseList', pleading.json);
        if (present === '') {
            return [];
        }
        const list: any[] =  Array.from(pleading.json.responseList.values());

        // sort pleadings list by clock date, then party number
        list.sort( function(p1, p2) {

            /* TSD00036882 The issue Sandeep is pointing out is that the response row without a
                    date should be sorted to the bottom. In the case referenced, WAKE 97CVS107,
                    the response without a date is not sorted to the bottom.  There is an additional
                    response with a date that is below the one without a date.
            */
            if (p1.clockDate === undefined) {
                return 1;   // Returning a 1 forces this to be compared as greater than the compared item,
                            // pushing it to the bottom of the list.
            }
            const compare = p1.clockDate.localeCompare(p2.clockDate);
            if (compare !== 0) {
                return compare;
            }
            if (p1.partyList === undefined) {
                return 0;
            }
            return p1.partyList[0].partyNumber - p2.partyList[0].partyNumber;
        });
        return list;
    }
    getRespondingPartyList(response: any): any[] {
        const present = SafeJSON.get('partyList', response);
        if (present === '') {
            return [];
        }
        const list: any[] =  Array.from(response.partyList.values());

        // sort pleadings list by clock date, then by pleading type (name)
        list.sort( function(p1, p2) {
            return p1.partyNumber - p2.partyNumber;
        });
        return list;
    }
    ////////////////////////////////////////////////////////////////
    getOrderByIssueKey(issueKey: string): any {
    }
    getType(): string {
        return SafeJSON.get('pleadingType.description', this.json);
    }
    getClockDate(): string {
        return SafeJSON.get('clockDate', this.json);
    }
    getPleadingTypeDescription(): string {
        return SafeJSON.get('pleadingType.description', this.json);
    }
    /*
        The Order Result box should
        only appear when an issue has no parties and an orderRef exists in the JSON.

        If you use the attached JSON, you will see on lines 304-313, that there are
        no issuePartyCodes.  So this is when the order result section should be populated.  Steve Savino
    */
    getIssueOrderResult(issueKey: string, partyKeys: string[], orderList: any []): string {
        if (orderList === undefined) {
            return '-';
        }
        if (partyKeys.length !== 0) {
            return '-';
        }

        const length = orderList.length;
        for (let i = 0; i < length; i++) {
            const orderIssueKey = SafeJSON.get('issueKey', orderList[i].json);
            if (orderIssueKey === '') {
                return '-';
            }
            if (issueKey === orderIssueKey) {
                const result = SafeJSON.getWithDefault('orderResultCode.description',  orderList[i].json);
                return result;
            }
        }
        return '-';
    }
    getIssueOrderResultClockDate(issueKey: string, partyKeys: string[], orderList: any []): string {
        if (orderList === undefined) {
            return '';
        }
        if (partyKeys.length !== 0) {
            return '';
        }

        const length = orderList.length;
        for (let i = 0; i < length; i++) {
            const orderIssueKey = SafeJSON.get('issueKey', orderList[i].json);
            if (orderIssueKey === '') {
                return '';
            }
            if (issueKey === orderIssueKey) {
                return SafeJSON.get('clockDate',  orderList[i].json);
            }
        }
        return '';
    }
    getPartyOrderResult(orderRef: any, orders: any): string {
        if (orders === undefined) {
            return '-';
        }
        const orderList: Object [] = orders;
        const length = orderList.length;

        for (let i = 0; i < length; i++) {
            const orderKey: string = orders[i].key;

            if (orderRef === orderKey) {
                const result = SafeJSON.get('orderResultCode.description', orders[i].json);
                if (result === '') {
                    return '';
                }
                return result;
            }
        }
        return '-';
    }
    getPartyOrderResultClockDate(orderRef: string, orders: any): string {
        if (orders === undefined) {
            return '';
        }
        const orderList: Object [] = orders;
        const length = orderList.length;

        for (let i = 0; i < length; i++) {
            const orderKey: string = orders[i].key;

            if (orderRef === orderKey) {
                return SafeJSON.get('clockDate', orders[i].json);
            }
        }
        return '';
    }

    /*
    FBR510	If the judgment is partially abstracted in VCAP and the book and page value
            is not equal to ‘888 888’ or ‘999 999’ for the abstract in VCAP,
            display the Book and Page Number and the electronic Abstract Type and
            Abstract Sequence Number assigned in CIPRS
            (Example: Order Book 123, Page 456 and Judgment A)
            else display only the electronic Abstract Type and Abstract Sequence Number
            assigned in CIPRS. Example: Judgment A.

            Wake 1997CR100
    */
    getPartyAbstractRecordedIn(civilCase: CivilCase, abstractRef: string, orderRef: string, orders: any): string {
        if (orders === undefined || orderRef === '') {
            return '';
        }

        // FBR393 hide book/page is preJA is fully abstracted
        const isPreJAFullyAbstracted = this.getPreJaJudgementIsFullyAbtracted(abstractRef, civilCase);
        if (isPreJAFullyAbstracted === true) {
            return '';
        }

        const orderList: Object [] = orders;
        const length = orderList.length;

        for (let i = 0; i < length; i++) {
            const orderKey: string = orders[i].key;

            if (orderRef === orderKey) {
                const SPECIALBOOKPAGE888 = '888';
                const SPECIALBOOKPAGE999 = '999';

                const docketBookNum = SafeJSON.get('docketBookNum', orders[i].json);
                const docketPageNum = SafeJSON.get('docketPageNum', orders[i].json);

                if (docketBookNum === '' || docketBookNum === 'null' ||
                    docketPageNum === '' || docketPageNum === 'null') {
                        return '';
                }
                if (((docketBookNum === SPECIALBOOKPAGE888 && docketPageNum === SPECIALBOOKPAGE888) ||
                    (docketBookNum === SPECIALBOOKPAGE999 && docketPageNum === SPECIALBOOKPAGE999)) &&
                    abstractRef !== '') {
                    return '';
                }
                /*
                FBR511	If a temporary abstract number of ‘999 999’ is assigned in VCAP for an
                        order/judgment that has not been abstracted,
                        display “See clerk for additional details.”
                FBR558  For abstracts recorded with a book and page number of ‘888 888’,
                        if no judgment details exist or if all the judgment details have
                        been marked as deleted, display “See clerk for additional details".
                        >>> Just duplicate logic for FBR511 but for 888.
                */
                // How to determine if judgment is not abstracted?
                // Answer from Steve: You have to also check that there is no abstractRef in
                //   the issueOrderPartyRef for the same issue/party you are checking for
                //   docketBookNum logic you mentioned.
                if (docketBookNum === SPECIALBOOKPAGE999 && docketPageNum === SPECIALBOOKPAGE999 &&
                    abstractRef === '') {
                    return 'See clerk for additional details.';
                }
                if (docketBookNum === SPECIALBOOKPAGE888 && docketPageNum === SPECIALBOOKPAGE888 &&
                    abstractRef === '') {
                    return 'See clerk for additional details.';
                }
                return 'Order Book ' + docketBookNum + ', Page ' + docketPageNum;
            }
        }
        return '';
    }
    // WAKE 11CVD011203 has Pre & Post JA
    getPartyAbstractInfo(abstractRef: string, civilCase: CivilCase): string {
        if (abstractRef === '') {
            return '-';
        }
        const abstract: Abstract = civilCase.getAbstractByKey(abstractRef);
        if (abstract === undefined) {
            return '-';
        }
        const fieldTitle = abstract.getAbstractSectionTitle(true);
        return fieldTitle + ' ' + abstract.getAbstractJudgmentNumber();
    }
    // Pender 90CR001492 - Order Book 015, Page 269 and JUDGMENT A
    // Nash 1988CR3813 - JUDGMENT A
    getPartyPreJAAbstractInfo(abstractRef: string, civilCase: CivilCase, orderRef: string, orders: any): string {
        if (abstractRef === '') {
            return '';
        }
        const preJaabstract: PreJaabstracts = civilCase.getPreJAAbstractByKey(abstractRef);
        if (preJaabstract === undefined) {
            return '';
        }
        const abstractNumber =  preJaabstract.getAbstractJudgmentNumber();
        if (abstractNumber !== '') {
            const includeAndConjunction = this.getPartyAbstractRecordedIn(civilCase, abstractRef, orderRef, orders);
            if (includeAndConjunction !== '') {
            return 'and JUDGMENT ' + abstractNumber;
            } else {
                return 'JUDGMENT ' + abstractNumber;
            }
        }
        return '';
    }
    getJudgementIsPartial(abstractRef: string, civilCase: CivilCase): boolean {
        if (abstractRef === '') {
            return false;
        }
        const preJaabstract: PreJaabstracts = civilCase.getPreJAAbstractByKey(abstractRef);
        if (preJaabstract === undefined) {
            return false;
        }
        const isPartiallyAbstracted =  preJaabstract.getIsPreJAPartiallyAbstracted();
        return isPartiallyAbstracted;
    }
    getPreJaJudgementIsFullyAbtracted(abstractRef: string, civilCase: CivilCase): boolean {
        if (abstractRef === '') {
            return false;
        }
        const preJaabstract: PreJaabstracts = civilCase.getPreJAAbstractByKey(abstractRef);
        if (preJaabstract === undefined) {
            return false;
        }
        const isFullyAbstracted =  preJaabstract.getIsPreJAFullyAbstracted();
        return isFullyAbstracted;
    }
    getRespondingPartyDescription(party: any): string {
        return SafeJSON.getWithDefault('partyRole.description', party);
    }
    getResponseStatus(response: any): string {
        let responseStatus = SafeJSON.getWithDefault('responseType.description', response);
        if (responseStatus === '-') {
            responseStatus = 'NO RESPONSE FOR THIS FILING';
        }
        return responseStatus;
    }
    getResponseClockDate(response: any): string {
        const responseStatus = SafeJSON.getWithDefault('responseType.description', response);
        if (responseStatus === '-') {
            return '';
        }
        return SafeJSON.get('clockDate', response);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/pleading.ts